var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var MODAL_IN_CSS_CLASS = 'in';
        var OVERFLOW_HIDDEN_CSS_CLASS = 'overflow-hidden';

        // TODO: добавить события начала и конца анимации показа/скрытия
        // Иногда нужно для того же сафари
        var events = {
            // Модалка создана и вставлена в DOM
            beforeShow: 'show.mpopup',
            // В модалку вставлен/загружен контент.
            // Анимация еще может быть не завершена или только начинаться
            afterShow: 'shown.mpopup',
            // Запущено закрытие модалки (старт)
            beforeHide: 'hide.mpopup',
            // Сразу по окончании анимации закрытия,
            // (До возвращения detachSelectorId контента в DOM и до удаления самой модалки из DOM)
            afterHide: 'hidden.mpopup'
        };

        /**
         * @property {HtModalOptions} params
         * @property {jQuery|string|HTMLElement} content
         * @property {jQuery|null} $contentDetachedParent
         * @property {jQuery} $modal
         * @property {jQuery} $modal
         */

        var ModalItem = function () {
            /**
             * @param {HtModalOptions} params
             */
            function ModalItem(params) {
                _classCallCheck(this, ModalItem);

                this.params = params;
                if (params.content.htmlDetachSelectorId.length) {
                    var $content = $('#' + params.content.htmlDetachSelectorId);
                    this.$contentDetachedParent = $content.parent();
                    this.content = $content.detach();
                } else {
                    this.content = params.content.html;
                    this.$contentDetachedParent = null;
                }

                this.$modal = $(this.getTargetSelector());
                this.$modal.data('targetSelector', this.getTargetSelector());
                this.$elems = {
                    header: this.$modal.find('.m-popup-header'),
                    footer: this.$modal.find('.m-popup-footer'),
                    content: this.$modal.find('.m-popup-content'), // scrollable
                    body: this.$modal.find('.m-popup-body'),
                    title: this.$modal.find('.m-popup-header .title')
                };
            }

            _createClass(ModalItem, [{
                key: "getTargetSelector",
                value: function getTargetSelector() {
                    return '#' + this.params.id;
                }

                /**
                 * @param {boolean|null} showHeader
                 * @param {boolean|null} showFooter
                 */

            }, {
                key: "toggleStickyButtons",
                value: function toggleStickyButtons() {
                    var showHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var showFooter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    if (showHeader !== null && this.$elems.header.length) {
                        this.$elems.header.toggleClass('hidden', !showHeader);
                    }
                    if (showFooter !== null && this.$elems.footer.length) {
                        this.$elems.footer.toggleClass('hidden', !showFooter);
                    }
                }

                /**
                 * @param {string} title
                 */

            }, {
                key: "setTitle",
                value: function setTitle(title) {
                    if (this.$elems.header.length) {
                        var $header = this.$elems.header;
                        var $label = this.params.labelFor ? $header.find('.m-popup-title__label') : [];
                        if ($label.length === 0) {
                            $label = $header.find('.m-popup-title');
                        }
                        $label.html(title);
                    }
                }
            }, {
                key: "show",
                value: function show() {
                    var _this = this;

                    $('body').addClass('m-popup-shown ' + OVERFLOW_HIDDEN_CSS_CLASS);
                    this.$modal.addClass('open');

                    setTimeout(function () {
                        _this.$modal.addClass(MODAL_IN_CSS_CLASS);
                    }, 10);
                }
            }, {
                key: "loadContent",
                value: function loadContent() {
                    var _this2 = this;

                    this.$modal.trigger(events.beforeShow);
                    if (this.params.content.url.length) {
                        this.$elems.body.html(this.getLoaderHTML()).load(this.params.content.url, function (data, status) {
                            if (_this2.params.onAfterShow) {
                                _this2.params.onAfterShow(_this2.$modal);
                            }

                            // TODO: style
                            if (status === 'error') {
                                _this2.showError({
                                    header: _this2.$elems.header,
                                    content: _this2.$elems.body,
                                    text: data
                                });
                            }

                            _this2.$modal.trigger(events.afterShow);
                        });
                    } else {
                        if (this.content.length) {
                            this.$elems.body.html(this.content);
                        }
                        if (this.params.onAfterShow) {
                            this.params.onAfterShow(this.$modal);
                        }
                        this.$modal.trigger(events.afterShow);
                    }
                    return true;
                }
            }, {
                key: "getLoaderHTML",
                value: function getLoaderHTML() {
                    return '<div class="loading-container loading-container--' + this.params.getType() + '">' + window.app.loading.circle + '</div>';
                }
            }, {
                key: "showError",
                value: function showError(params) {
                    var $content = params.content;
                    var text = params.text || 'Попробуйте позднее';

                    $content.html('<div class="site-error side-indent text-center">' + '<h2 class="site-header fw-b">Ошибка</h2>' + '<div class="site-error-description">' + text + '</div>' + '</div>');
                }
            }, {
                key: "hide",
                value: function hide() {
                    var _this3 = this;

                    var $body = $('body');

                    // Hide started
                    this.$modal.trigger(events.beforeHide);
                    if (typeof this.params.onBeforeClose === 'function') {
                        this.params.onBeforeClose(this.$modal);
                    }

                    this.$modal.removeClass(MODAL_IN_CSS_CLASS);
                    setTimeout(function () {
                        _this3.$modal.removeClass('open');
                        var $openedPopups = $('.m-popup.open');
                        if (!$openedPopups.length) {
                            $body.removeClass('m-popup-shown ' + OVERFLOW_HIDDEN_CSS_CLASS);
                        }

                        // hidden. Вызываем после того как вернули scroll на body
                        _this3.$modal.trigger(events.afterHide);

                        if (_this3.params.content.htmlDetachSelectorId.length) {
                            _this3.$contentDetachedParent.html($('#' + _this3.params.content.htmlDetachSelectorId).detach());
                        }

                        // Удаление
                        if (typeof _this3.params.onBeforeRemove === 'function') {
                            _this3.params.onBeforeRemove(_this3.$modal);
                        }
                        _this3.$modal.remove();
                    }, this.params.animationDuration);
                }

                // Корректный селектор

            }, {
                key: "isTargetValid",
                value: function isTargetValid() {
                    return this.$modal.length && this.$modal.hasClass('m-popup');
                }
            }]);

            return ModalItem;
        }();

        module.exports = {
            ModalItem: ModalItem,
            itemConstants: {
                IN_CSS_CLASS: MODAL_IN_CSS_CLASS
            },
            events: events
        };
    }, {}], 2: [function (require, module, exports) {
        var _require = require('./ModalItem'),
            ModalItem = _require.ModalItem,
            itemConstants = _require.itemConstants;

        var itemRender = require('./options/modal-item-render');
        var zIndex = 1000;

        /**
         * @property {string} titleHeader
         * @property {string} labelBackBtn
         * @property {string} labelFooterBtn
         */

        var MobileModalJsMessages = function MobileModalJsMessages() {
            _classCallCheck(this, MobileModalJsMessages);
        };

        var goBackDebugTimer = 0;
        function dispatchDebugEvent(message) {
            if (window.app.debug) {
                var event = new CustomEvent('modal.debugAlert', {
                    detail: {
                        message: message
                    }
                });
                window.dispatchEvent(event);
            }
        }

        var ModalManager = function () {
            function ModalManager() {
                _classCallCheck(this, ModalManager);

                if (window.brxModal) {
                    throw new Error('only one instance of ModalManager available');
                }

                /**
                 * @type {number}
                 */
                this.loadingTimestamp = new Date().getTime();

                /**
                 * Поддерживаем ли работу с history API
                 * @type {boolean}
                 */
                this.isHistorySupported = typeof window.history !== 'undefined';

                /**
                 * Когда идет одновременно закрытие history.go(-1) и открытие history.pushState({...})
                 * Блочим открытие до момента, пока не закончится закрытие
                 * @type {number}
                 */
                this.historyPushLockTimer = 0;

                /**
                 * Если пытались что-то открыть в момент, пока открытие было заблочено - откладываем
                 * @type {Array}
                 */
                this.delayedOpenExecution = [];

                /**
                 * z-index модалки
                 * @type {number}
                 */
                this.zIndex = 1000;

                /**
                 * кол-во модалок, открытых на текущий момент
                 * @type {number}
                 */
                this.visibleCount = 0;

                /**
                 * Кол-во модалок, открытых в пределах визита (1 страницы)
                 * ++ при открытии каждой новой модалки
                 * По совместитульству уникальный идетфикатор модалки
                 * @type {number}
                 */
                this.shownCount = 0;

                /**
                 * @type {{}}
                 */
                this.openedItemsByIndex = {};

                /**
                 * Отслеживаем только после загрузки страницы
                 * По history.state нельзя ориентироваться. На момент собыния popstate уже новое состояние
                 * @type {null|any}
                 */
                this.currentHistoryState = null;

                /**
                 * От срабатывания несколько раз .go(-1)
                 * @type {{}}
                 */
                this.popupCloseLocked = {};

                /**
                 * @type {ModalItem}
                 */
                this.closeTargetItem = null;

                this.attachHandlers();
            }

            /**
             * @param {HtModalOptions} options
             * @param {boolean} ignoreLock
             * @return {boolean}
             */


            _createClass(ModalManager, [{
                key: "open",
                value: function open(options) {
                    var _this4 = this;

                    var ignoreLock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    if (!options.validate()) {
                        return false;
                    }
                    if (this.isHistorySupported) {
                        if (this.historyPushLockTimer && !ignoreLock) {
                            // Откладываем выполнение
                            this.delayedOpenExecution.push(function () {
                                _this4.open(options, true);
                            });

                            console.info('modal open postponed dew to history API conflict');
                            return false;
                        }
                    }

                    // render modal
                    document.body.appendChild(itemRender(options, zIndex++));

                    var modalItem = new ModalItem(options);
                    if (!modalItem.isTargetValid()) {
                        console.error('Something went wrong. Can`t open modal');
                        return false;
                    }

                    // Анимация показа
                    modalItem.show();
                    // Если модалка не показана
                    if (!this._isOpenedNow(modalItem)) {
                        this.visibleCount++;
                        this.shownCount++;

                        this.openedItemsByIndex[this.shownCount] = modalItem;
                        modalItem.$modal.data('index', this.shownCount);

                        if (this.isHistorySupported) {
                            // Была закрыта. Показываем
                            this._unlockClose(modalItem.getTargetSelector());
                            history.pushState({
                                type: 'm-popup',
                                index: this.shownCount,
                                sessionTimestamp: this.loadingTimestamp
                            }, document.title);
                        }
                    } else {
                        console.warn('requested modal is already opened');
                        // Закрываем все что открыто после,
                        // Чтобы вернуть history.state к состоянию текущей модалки
                        // TODO:
                    }
                    modalItem.loadContent();

                    return true;
                }

                /**
                 * Закрытие модалки с кнопки в интерфейсе
                 * @param $self - элемент, по которому нажали
                 * @param {*} popupSelector - Не используется при включенной истории
                 */

            }, {
                key: "close",
                value: function close($self, popupSelector) {
                    var $popup = null;
                    if (typeof popupSelector !== 'undefined' && popupSelector.length) {
                        $popup = $(popupSelector);
                    } else {
                        $popup = $self.closest('.m-popup');
                    }

                    popupSelector = $popup.data('targetSelector');
                    var targetModalItem = this._getOpenedModalItemByJqueryElement($popup);
                    if (this.isHistorySupported) {
                        if (this.haveOpened()) {
                            var currentState = this._parseCurrentState();
                            var closeTargetSelector = currentState.targetModalItem.getTargetSelector();
                            if (!targetModalItem) {
                                console.warn('target modal "%s" is not opened', popupSelector);
                                console.warn('last opened now is "%s"', closeTargetSelector);
                            } else {
                                if (closeTargetSelector !== targetModalItem.getTargetSelector()) {
                                    console.warn('target modal "%s" is opened (not last opened)', popupSelector);
                                    console.warn('last opened now is "%s"', closeTargetSelector);
                                }
                            }
                            if (!$popup.hasClass(itemConstants.IN_CSS_CLASS)) {
                                // Если модалка, в которой нажали кнопку или передали как селектор, закрыта
                                console.warn('blocked close for "%s"', closeTargetSelector);
                                return;
                            }
                        }
                        // Закрываем последнюю открытую
                        this._closeLast();
                    } else {
                        this.closeTargetItem = targetModalItem;
                        this._runClose();
                    }

                    return true;
                }
            }, {
                key: "_closeLast",
                value: function _closeLast() {
                    if (!this.isHistorySupported) {
                        return false;
                    }
                    var self = this;
                    var currentState = this._parseCurrentState();
                    if (currentState.targetModalItem) {
                        // От двойных срабатываний .go(-1) при закрытии одной и той же модалки
                        // При следующем открытии снимаем флаг
                        if (!this._isCloseLocked(currentState.targetModalItem.getTargetSelector())) {
                            this._lockClose(currentState.targetModalItem.getTargetSelector());

                            if (this.historyPushLockTimer) {
                                clearTimeout(this.historyPushLockTimer);
                                this.historyPushLockTimer = 0;
                            }

                            this.historyPushLockTimer = setTimeout(function () {
                                self._onAfterHistoryPushUnlock();
                            }, 10);

                            goBackDebugTimer = setTimeout(function () {
                                dispatchDebugEvent('modal popstate event was not fired after 100ms from go(-1)');
                            }, 100);

                            // Закрытие в popstate
                            // Закрывает модалку из this._parseCurrentState();
                            history.go(-1);

                            return true;
                        } else if (window.app.debug) {
                            dispatchDebugEvent('modal close locked. consider check onpopstate event listener');
                        }
                    }

                    return false;
                }
            }, {
                key: "_runClose",
                value: function _runClose() {
                    var modalItem = this.closeTargetItem;
                    if (!modalItem || !this._isOpenedNow(modalItem)) {
                        return false;
                    }
                    var openedModalIndex = modalItem.$modal.data('index');
                    delete this.openedItemsByIndex[openedModalIndex];
                    if (this.visibleCount) {
                        this.visibleCount--;
                    }
                    if (this.visibleCount === 0) {
                        this.openedItemsByIndex = {};
                    }
                    // Set default
                    this.closeTargetItem = null;

                    modalItem.hide();
                }
            }, {
                key: "haveOpened",
                value: function haveOpened() {
                    return this.visibleCount > 0;
                }
            }, {
                key: "attachHandlers",
                value: function attachHandlers() {
                    var _this5 = this;

                    if (this.isHistorySupported) {
                        this._attachHistoryStateHandlers();
                    }
                    $(document).ready(function () {
                        _this5._attachDOMHandlers();
                    });
                }
            }, {
                key: "_attachDOMHandlers",
                value: function _attachDOMHandlers() {
                    var self = this;
                    var touchStartY = 0;
                    var touchEndY = 0;

                    $('body').on('click', '.m-popup-close', function (e) {
                        self.close($(e.currentTarget));
                    }).on('click', '.m-popup-overlay', function (e) {
                        self.close($(e.currentTarget));
                    }).on('touchstart', function (e) {
                        touchStartY = e.originalEvent.touches[0].clientY;
                    }).on('touchend', function (e) {
                        touchEndY = e.originalEvent.changedTouches[0].clientY;
                        if (touchEndY - touchStartY > 50) {
                            // Если свайп вниз больше 50px закрываем активную модалку
                            var $openModal = $('.m-popup:visible'); // Находим открытую модалку
                            if ($openModal.length) {
                                self.close($openModal);
                            }
                        }
                    });
                }
            }, {
                key: "_attachHistoryStateHandlers",
                value: function _attachHistoryStateHandlers() {
                    if (!this.isHistorySupported) {
                        return false;
                    }

                    var self = this;
                    (function (history) {
                        var pushState = history.pushState;
                        history.pushState = function (state) {
                            self._onPushState({
                                state: state
                            });
                            return pushState.apply(history, arguments);
                        };
                    })(window.history);

                    window.addEventListener('popstate', function (e) {
                        self._onPopState(e);
                    }, false);

                    return true;
                }
            }, {
                key: "_onPushState",
                value: function _onPushState(e) {
                    this.currentHistoryState = e.state;
                }
            }, {
                key: "_onPopState",
                value: function _onPopState(e) {
                    if (goBackDebugTimer) {
                        clearTimeout(goBackDebugTimer);
                    }
                    // Предыдущее состояние, до popstate
                    var previousState = this._parseCurrentState();
                    // Обновляем текущее состояние истории
                    this.currentHistoryState = e.state;

                    if (this.haveOpened() && previousState.isCurrentSessionState && previousState.targetModalItem) {
                        // Если в предыдущем состоянии была наша модалка - закрываем
                        this.closeTargetItem = previousState.targetModalItem;
                        this._runClose();
                    }
                }

                /**
                 * @return {{isModalState: boolean, isCurrentSessionState: boolean, targetModalItem: ModalItem}}
                 * @private
                 */

            }, {
                key: "_parseCurrentState",
                value: function _parseCurrentState() {
                    var state = this.currentHistoryState;
                    var isModalState = state !== null && (typeof state === "undefined" ? "undefined" : _typeof(state)) === 'object' && state.type === 'm-popup';
                    var isCurrentSessionState = isModalState && state.sessionTimestamp === this.loadingTimestamp;

                    return {
                        isModalState: isModalState,
                        isCurrentSessionState: isCurrentSessionState,
                        targetModalItem: isCurrentSessionState ? this._getOpenedModalItemByIndex(state.index) : null
                    };
                }

                /**
                 *
                 * @param index
                 * @return {ModalItem|null}
                 * @private
                 */

            }, {
                key: "_getOpenedModalItemByIndex",
                value: function _getOpenedModalItemByIndex(index) {
                    return this.openedItemsByIndex[index] || null;
                }

                /**
                 *
                 * @param $modal
                 * @return {ModalItem|null}
                 * @private
                 */

            }, {
                key: "_getOpenedModalItemByJqueryElement",
                value: function _getOpenedModalItemByJqueryElement($modal) {
                    var openedModalIndex = $modal.length && $modal.hasClass('m-popup') ? $modal.data('index') : null;
                    var modalItem = this._getOpenedModalItemByIndex(openedModalIndex);
                    if (modalItem && this._isOpenedNow(modalItem)) {
                        return modalItem;
                    }

                    return null;
                }

                /**
                 * @param {jQuery} $child
                 * @return {ModalItem|null}
                 */

            }, {
                key: "getOpenedNowModalItemByChild",
                value: function getOpenedNowModalItemByChild($child) {
                    return this._getOpenedModalItemByJqueryElement($child.closest('.m-popup'));
                }
            }, {
                key: "_onAfterHistoryPushUnlock",
                value: function _onAfterHistoryPushUnlock() {
                    var len = this.delayedOpenExecution.length;
                    if (len) {
                        var i = void 0;
                        for (i = 0; i < len; i++) {
                            this.delayedOpenExecution[i]();
                        }
                        this.delayedOpenExecution = [];
                    }
                    this.historyPushLockTimer = 0;
                }

                // Для одной и той же модалки не делать go(-1) несколько раз,
                // пока снова не будет записи в источрии

            }, {
                key: "_lockClose",
                value: function _lockClose(popupSelector) {
                    this.popupCloseLocked[popupSelector] = 1;
                }

                // При новом открытии, вместе с pushState

            }, {
                key: "_unlockClose",
                value: function _unlockClose(popupSelector) {
                    this.popupCloseLocked[popupSelector] = 0;
                }

                // Уже вызвано событие закрытия для этой модалки.
                // Пока не закроется не вызывать history.go(-1) для этой модалки

            }, {
                key: "_isCloseLocked",
                value: function _isCloseLocked(popupSelector) {
                    return this.popupCloseLocked.hasOwnProperty(popupSelector) && this.popupCloseLocked[popupSelector] === 1;
                }
            }, {
                key: "_isOpenedNow",
                value: function _isOpenedNow(modalItem) {
                    var shownIndex = modalItem.$modal.data('index');
                    // if popup was shown sometime ago OR was shown and closed at least once
                    return shownIndex && this.openedItemsByIndex.hasOwnProperty(shownIndex);
                }
            }]);

            return ModalManager;
        }();

        module.exports = ModalManager;
    }, { "./ModalItem": 1, "./options/modal-item-render": 4 }], 3: [function (require, module, exports) {
        var SIZE_SM = 'sm';
        var THEME_DEFAULT = 'default';
        var THEME_SECONDARY = 'secondary';
        var THEME_TRANSPARENT = 'transparent';
        var THEME_PRIMARY = 'primary';
        var TYPE_FULL = 'full';
        var TYPE_BOTTOM = 'bottom';
        var TYPE_FLOATING = 'floating';

        module.exports = {
            SIZE_SM: SIZE_SM,
            THEME_DEFAULT: THEME_DEFAULT,
            THEME_SECONDARY: THEME_SECONDARY,
            THEME_TRANSPARENT: THEME_TRANSPARENT,
            THEME_PRIMARY: THEME_PRIMARY,
            TYPE_FULL: TYPE_FULL,
            TYPE_BOTTOM: TYPE_BOTTOM,
            TYPE_FLOATING: TYPE_FLOATING
        };
    }, {}], 4: [function (require, module, exports) {
        var _require2 = require('./constant'),
            THEME_TRANSPARENT = _require2.THEME_TRANSPARENT;

        /**
         * @param {HtModalOptions} options
         * @param {number} zIndex
         * @return {HTMLDivElement}
         */


        module.exports = function (options, zIndex) {
            var _popup$classList, _overlay$classList, _contentBody$classLis;

            var popup = document.createElement('div');
            popup.id = options.id;
            (_popup$classList = popup.classList).add.apply(_popup$classList, ['m-popup', 'm-popup--' + options.type]);

            var overlay = document.createElement('div');
            overlay.setAttribute('role', 'button');
            (_overlay$classList = overlay.classList).add.apply(_overlay$classList, ['m-popup-overlay', 'm-popup-overlay--blurred', 'fade-animation']);

            var content = options.content.render();
            if (options.fixContentMaxHeight) {
                content.classList.add('fix-max-height');
            }

            var isContentBg = true;
            if (options.header) {
                if (options.header.isSticky()) {
                    popup.classList.add('fixed-header');
                }
                // header внутри content для sticky
                content.append(options.header.render());
                isContentBg = !options.header.isTransparent();
            }

            var contentBody = document.createElement('div');
            (_contentBody$classLis = contentBody.classList).add.apply(_contentBody$classLis, ['m-popup-body']);
            if (options.footer && options.footer.height !== null) {
                contentBody.style.paddingBottom = options.footer.height + 'px';
            }
            if (isContentBg) {
                content.classList.add('theme-' + options.content.theme);
            } else {
                contentBody.classList.add('theme-' + options.content.theme);
                contentBody.classList.add('rounded-top');
                content.classList.add('theme-' + THEME_TRANSPARENT); // overwrite defaults
            }
            content.append(contentBody);

            popup.append(overlay);
            popup.append(content);
            if (options.footer !== null) {
                var footer = options.footer.render();
                footer.style.zIndex = zIndex;
                popup.classList.add('fixed-footer');
                popup.append(footer);
            }
            content.style.zIndex = zIndex;
            popup.style.zIndex = zIndex;

            return popup;
        };
    }, { "./constant": 3 }], 5: [function (require, module, exports) {
        var i18nMessages = {
            labelBackBtn: 'Закрыть',
            labelSelect: 'Выбрать'
        };

        var c = require('./constant');

        /**
         * @property {string} title
         * @property {string|null} titleSize - см. c.SIZE_{TYPE}
         * @property {string|null} titleFor
         * @property {'center'|'left'} titleAlign
         * @property {HTMLElement|string|null} html - custom content
         */

        var HtModalHeader = function () {
            function HtModalHeader(props) {
                _classCallCheck(this, HtModalHeader);

                this.title = props.title;
                this.titleSize = props.titleSize || null;
                this.titleFor = props.titleFor || null;
                this.titleAlign = props.titleAlign || 'center';
                this.html = props.html || null; // custom content
                this.theme = props.theme || c.THEME_DEFAULT;
            }

            _createClass(HtModalHeader, [{
                key: "isTransparent",
                value: function isTransparent() {
                    return this.theme === c.THEME_TRANSPARENT;
                }
            }, {
                key: "isSticky",
                value: function isSticky() {
                    return !this.isTransparent();
                }

                /** @return HTMLDivElement */

            }, {
                key: "render",
                value: function render() {
                    var _header$classList;

                    var header = document.createElement('div');
                    (_header$classList = header.classList).add.apply(_header$classList, ['m-popup-header', 'theme-' + this.theme]);

                    if (this.isTransparent()) {
                        header.append(this.renderCloseButton());
                    } else {
                        header.classList.add('m-popup-header--rounded');
                        if (this.isSticky()) {
                            header.classList.add('sticky');
                        }
                        header.innerHTML = this.renderTitle();
                        if (this.html !== null) {
                            var customContent = document.createElement('div');
                            customContent.classList.add('m-popup-header__content custom-content'); // m-popup-header__content
                            customContent.innerHTML = this.html;
                            header.append(customContent);
                        }
                    }

                    return header;
                }

                /**
                 * @private
                 * @return {HTMLDivElement}
                 */

            }, {
                key: "renderTitle",
                value: function renderTitle() {
                    var titleContent = void 0;
                    if (this.titleFor) {
                        titleContent = "<label class=\"m-popup-title__label\" for=\"" + this.titleFor + "\">" + this.title + "</label>";
                    } else {
                        titleContent = this.title;
                    }

                    var classList = ['m-popup-title', 'align-' + this.titleAlign]; // header-title => m-popup-title
                    if (this.titleSize !== null) {
                        classList.push('m-popup-title--' + this.titleSize);
                    }
                    return '<div class="' + classList.join(' ') + ' text-ellipsis">' + titleContent + '</div>' + '<div class="aside-right">' + '<button type="button"' + ' class="m-popup-header__close-circle m-popup-close"' + ' aria-label="' + i18nMessages.labelBackBtn + '"></button>' + '</div>';
                }
            }, {
                key: "renderCloseButton",
                value: function renderCloseButton() {
                    var _button$classList;

                    var button = document.createElement('button');
                    button.type = 'button';
                    (_button$classList = button.classList).add.apply(_button$classList, ['m-popup-header__close-cross', 'm-popup-close']);
                    button.innerHTML = '<span class="icon-close" aria-label="' + i18nMessages.labelBackBtn + '">✕</span>';
                    return button;
                }
            }]);

            return HtModalHeader;
        }();

        /**
         * Одновременно можно использовать только 1 из доступных способов:
         * @property {HTMLElement|string} html - Значение будет выведено в качестве контента
         * @property {string} htmlDetachSelectorId - Элемент со страницы будет выведен в качестве контента
         * @property {string} url - Контент будет загружен отложено
         * @property {string} theme - Тема модалки
         */


        var HtModalContent = function () {
            function HtModalContent(props) {
                _classCallCheck(this, HtModalContent);

                this.html = props.html || '';
                this.htmlDetachSelectorId = props.htmlDetachSelectorId || '';
                this.url = props.url || '';
                this.theme = props.theme || c.THEME_DEFAULT;
            }

            /** @return {HTMLDivElement} */


            _createClass(HtModalContent, [{
                key: "render",
                value: function render() {
                    var _content$classList;

                    var content = document.createElement('div');
                    (_content$classList = content.classList).add.apply(_content$classList, ['m-popup-content']);
                    return content;
                }
            }]);

            return HtModalContent;
        }();

        /**
         * @property {string} theme
         * @property {string} buttonLabel
         * @property {string} buttonCssClass
         * @property {number|null} height
         */


        var HtModalFooter = function () {
            function HtModalFooter(props) {
                _classCallCheck(this, HtModalFooter);

                this.theme = props.theme || THEME_DEFAULT;
                this.buttonLabel = props.buttonLabel || i18nMessages.labelSelect;
                this.buttonCssClass = props.buttonCssClass || '';
                this.height = props.height || null;
            }

            /** @return {HTMLDivElement} */


            _createClass(HtModalFooter, [{
                key: "render",
                value: function render() {
                    var _footer$classList;

                    var footer = document.createElement('div');
                    (_footer$classList = footer.classList).add.apply(_footer$classList, ['m-popup-footer', 'fade-animation', 'theme-' + this.theme]);
                    footer.append(this.renderButton());

                    return footer;
                }

                /**
                 * @private
                 * @return {HTMLButtonElement}
                 */

            }, {
                key: "renderButton",
                value: function renderButton() {
                    var _button$classList2;

                    var button = document.createElement('button');
                    button.type = 'button';
                    var classList = 'ht-button ht-button--primary m-popup-close';
                    if (this.buttonCssClass !== '') {
                        classList += ' ' + this.buttonCssClass;
                    }
                    classList = classList.trim().split(' ');
                    (_button$classList2 = button.classList).add.apply(_button$classList2, _toConsumableArray(classList));
                    button.innerHTML = this.buttonLabel;

                    return button;
                }
            }, {
                key: "getCssHeight",
                value: function getCssHeight() {
                    if (this.height === null) {
                        return null;
                    }
                    return this.height + 'px';
                }
            }]);

            return HtModalFooter;
        }();

        /**
         * @property {string} id - Selecor ID модалки.
         *  Для обратной совместимости с формой поиска.
         *  Нежелательно передавать снаружи
         * @property {HtModalContent} content - настройки отображения контента
         * @property {HtModalHeader|null} header - настройки отображения шапки
         * @property {HtModalFooter|null} footer - настройки отображения футера
         * @property {Function|null} onAfterShow - колбек перед началом показа
         * @property {Function|null} onBeforeClose - колбек перед закрытием
         * @property {Function|null} onBeforeRemove - колбек перед удалением из DOM
         */


        var HtModalOptions = function () {
            function HtModalOptions(props) {
                _classCallCheck(this, HtModalOptions);

                // required
                this.header = props.header;
                this.content = props.content;
                // optional
                this.id = props.id || this.randomId();
                this.type = props.type || c.TYPE_BOTTOM;
                this.fixContentMaxHeight = props.fixContentMaxHeight || false;
                this.footer = props.footer || null;
                this.onAfterShow = typeof props.onAfterShow === 'function' ? props.onAfterShow : null;
                this.onBeforeClose = typeof props.onBeforeClose === 'function' ? props.onBeforeClose : null;
                this.onBeforeRemove = typeof props.onBeforeRemove === 'function' ? props.onBeforeRemove : null;
            }

            _createClass(HtModalOptions, [{
                key: "randomId",
                value: function randomId() {
                    return 'm-popup--id-' + new Date().getTime() + '-' + Math.ceil(Math.random() * 1000);
                }

                /**
                 * Длительности анимации может отличаться в зависимости от типа
                 * @return {number}
                 */

            }, {
                key: "validate",
                value: function validate() {
                    return this.content.html || this.content.htmlDetachSelectorId || this.content.url;
                }
            }, {
                key: "animationDuration",
                get: function get() {
                    return 400;
                }
            }]);

            return HtModalOptions;
        }();

        /**
         * Построение конфигурации из объекта
         * @param optionsConfig
         * @return {HtModalOptions}
         */


        function buildHtModalOptions(optionsConfig) {
            if (optionsConfig instanceof HtModalOptions) {
                return optionsConfig;
            }

            var footer = null;
            if (optionsConfig.footer) {
                footer = new HtModalFooter(optionsConfig.footer);
            }
            var header = null;
            if (optionsConfig.header) {
                header = new HtModalHeader(optionsConfig.header);
            }

            return new HtModalOptions({
                id: optionsConfig.id,
                type: optionsConfig.type,
                // sections
                header: header,
                footer: footer,
                content: new HtModalContent(optionsConfig.content),
                // settings
                fixContentMaxHeight: optionsConfig.fixContentMaxHeight || null,
                // callbacks
                onAfterShow: optionsConfig.onAfterShow || null,
                onBeforeClose: optionsConfig.onBeforeClose || null,
                onBeforeRemove: optionsConfig.onBeforeRemove || null
            });
        }

        module.exports = {
            build: buildHtModalOptions,
            themes: {
                DEFAULT: c.THEME_DEFAULT,
                SECONDARY: c.THEME_SECONDARY,
                TRANSPARENT: c.THEME_TRANSPARENT,
                PRIMARY: c.THEME_PRIMARY
            },
            sizes: {
                SM: c.SIZE_SM
            },
            types: {
                FULL: c.TYPE_FULL,
                BOTTOM: c.TYPE_BOTTOM,
                FLOATING: c.TYPE_FLOATING
            }
        };
    }, { "./constant": 3 }], 6: [function (require, module, exports) {
        var ModalManager = require('./helpers/ModalManager');
        var options = require('./helpers/options/options');

        // modal
        var manager = new ModalManager();
        var modal = {
            /**
             * Показать модалку
             * Принимает подобный классу объект.
             * Объект указан как тип для подсветки
             * @param {HtModalOptions|{}} config
             */
            open: function open(config) {
                manager.open(options.build(config));
            },
            /**
             * @param {jQuery} $child
             * @param {Function|null} onAfterHide - пробрость колбек после закрытия
             *      e.g. Закрыть модалку опционально, и показать еще одну. Порядок действий важен
             * @return {boolean}
             */
            closeParent: function closeParent($child) {
                var onAfterHide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                var item = manager.getOpenedNowModalItemByChild($child);
                if (item) {
                    if (onAfterHide !== null) {
                        item.$modal.one('hidden.mpopup', function () {
                            onAfterHide();
                        });
                    }
                    manager.close(null, item.getTargetSelector());
                    return true;
                }
                return false;
            },
            /**
             * Находится ли элемент внутри открытой модалки
             * @param {jQuery} $child
             * @return {boolean}
             */
            isChild: function isChild($child) {
                return !!manager.getOpenedNowModalItemByChild($child);
            },
            /**
             * Must be called before openPopup
             * (in case both called at the same time "close_popup(selector)" and "open_popup")
             * @param {string} targetSelector - ignored, everytime will be closed top m-popup
             */
            close: function close(targetSelector) {
                manager.close(null, targetSelector);
            },
            /**
             * Показать/скрыть прилипающие кнопки
             * @param {jQuery} $child
             * @param {boolean|null} showHeader
             * @param {boolean|null} showFooter
             */
            toggleParentStickyButtons: function toggleParentStickyButtons($child, _ref) {
                var _ref$showHeader = _ref.showHeader,
                    showHeader = _ref$showHeader === undefined ? null : _ref$showHeader,
                    _ref$showFooter = _ref.showFooter,
                    showFooter = _ref$showFooter === undefined ? null : _ref$showFooter;

                var item = manager.getOpenedNowModalItemByChild($child);
                if (item) {
                    item.toggleStickyButtons(showHeader, showFooter);
                }
            },
            /**
             * Изменить title в уже открытой модалке
             * @param {jQuery} $child
             * @param {string} title
             */
            setTitle: function setTitle($child, title) {
                var item = manager.getOpenedNowModalItemByChild($child);
                if (item) {
                    item.setTitle(title);
                }
            },

            types: options.types,
            themes: options.themes,
            sizes: options.sizes
        };

        module.exports = modal;
    }, { "./helpers/ModalManager": 2, "./helpers/options/options": 5 }], 7: [function (require, module, exports) {
        /**
         * Created by vikf on 9/29/16.
         */

        window.brxModal = require('../../../../mobile-lite/include/modal/_js/modal');

        var HotelViewNew = function () {
            function HotelViewNew(params) {
                _classCallCheck(this, HotelViewNew);

                this.elems = {
                    $root: $('#' + params.id)
                };
                if (0 === this.elems.$root.length) {
                    return;
                }

                this.swiper = null;
                this.elems.$spinner = this.elems.$root.find('.spinner');
                this.timer = null;
                this.slidesPerView = params.widgetParams.slidesPerView || 3.1;
                this.offBreakpoints = params.widgetParams.offBreakpoints || false;

                //v1
                this.elems.$citySelect = this.elems.$root.find('#s_w-moffers__city');
                this.elems.$cityName = this.elems.$root.find('.w-moffers__city-name');

                this.translate = params.translate;
                this.links = params.links;

                this.handlers();

                this.template = {};
                this.template.days = '<div class="w-of-item__days-to-end">{{leftText}}: {{days_place}}</div>';
                this.template.all = '<div class="swiper-slide">' + '<div class="w-of-item w-of-item__last w-of-item__all">' + '<div class="w-of-item-wrapper">' + '<div class="w-of-item__last-img">' + '<img src="/img/hotel-offer-item-all.png" alt="">' + '</div>' + '<div class="w-of-item__last-title">' + this.translate.moreHotToursText + '</div>' + '<div class="w-of-item__last-hint">' + this.translate.suiteYouText + '</div>' + '<div class="w-of-item__button">' + '<noindex>' + '<a href="/hottours" class="h-button w-of-item__change">' + this.translate.viewLabel + '</a>' + '</noindex>' + '</div>' + '</div>' + '</div>' + '</div>';
                this.template.discount = '<div class="w-of-item__change" data-href="{{link}}">\
            <span class="w-of-item__discount dib">{{discount_value}}</span>\
        </div>';
                this.template.country = '<div class="w-of-item__country">\
            <img src="/fls/flag/round/{{country_code}}.svg" alt="{{country_name}}">\
            {{country_name}}\
        </div>';
                this.template.lazyPreloader = '<div class="swiper-lazy-preloader"></div>';
                this.template.main = '<div class="swiper-slide">\
                <div class="w-of-item">\
                    <div class="w-of-item-wrapper">\
                        <div class="w-of-item__img-wrapper rel">\
                            <div class="w-of-item__img">\
                                <a href="{{link}}">\
                                    <img {{lazyImgParams}}src="//ht.kz/fls/post/{{file}}" alt="{{title}}">\
                                    {{discount_template_place}}\
                                </a>\
                            </div>\
                            {{days_template_place}}\
                            {{country_template_place}}\
                            <div>{{lazyPreloader}}</div>\
                        </div>\
                        <span class="w-of-item__title">\
                            <a href="{{link}}">{{title}}</a>\
                        </span>\
                        <div class="w-of-item__price">{{price_place}}</div>\
                        <div class="w-of-item__button">\
                            <a href="{{link}}" class="btn-clear h-button">{{view_tour}}</a>\
                        </div>\
                    </div>\
                </div>\
            </div>';

                this.cache = [];
            }

            _createClass(HotelViewNew, [{
                key: "renderDiscount",
                value: function renderDiscount(props) {}
            }, {
                key: "handlers",
                value: function handlers() {
                    //Swiper
                    var self = this;
                    $(document).ready(function () {
                        $('.w-of-item__button').on('click', '', function () {
                            window.showPageLoader();
                        });
                        // initialize swiper when document ready
                        var breakpoints = {
                            // when window width is <= 320px
                            380: {
                                slidesPerView: 1.3
                            },
                            420: {
                                slidesPerView: 1.3
                            },
                            480: {
                                slidesPerView: 1.5
                            },
                            580: {
                                slidesPerView: 1.6
                            },
                            680: {
                                slidesPerView: 1.9
                            },
                            820: {
                                slidesPerView: 2.2
                            }
                        };

                        var swipeCount = 0;
                        self.swiper = new Swiper('.w-moffers__all .swiper-container', {
                            // Optional parameters
                            direction: "horizontal",
                            setWrapperSize: true,
                            spaceBetween: 0,
                            slidesPerView: self.slidesPerView, //3.1,
                            //centeredSlides: true,
                            grabCursor: true,
                            preloadImages: false,
                            watchSlidesVisibility: false,
                            watchSlidesProgress: false,
                            lazy: {
                                loadPrevNext: true,
                                loadPrevNextAmount: 4,
                                loadOnTransitionStart: true
                            },
                            on: {
                                slideChange: function slideChange() {
                                    if (!swipeCount) {
                                        window.brxTracking.sendAnalyticsEvent('hot_tours_slider_swipe_mobile');
                                        swipeCount = 1;
                                    }
                                }
                            },
                            breakpoints: self.offBreakpoints ? {} : breakpoints
                        });

                        if (0 !== self.elems.$citySelect.length) {
                            self.elems.$citySelect.on('change', function () {
                                var city_id = parseInt($(this).val(), 10);
                                var changeGlobalCity = parseInt($(this).data('changeGlobalCity'), 10);
                                // var cityName = $(this).find('option[value='+city_id+']').text();
                                // self.elems.$cityName.text(cityName);
                                self.onCityChange(city_id, changeGlobalCity);
                                // восстанавливаем значение чтобы при след. изменении всё было ок
                                $(this).data('changeGlobalCity', 1);
                            });
                        }

                        $(window).on('onLocation', function (event, city, city_id) {
                            if (city_id && cities.hasOwnProperty(city_id)) {
                                var realCityID = cities[city_id].phoneCity.id;
                                if (self.elems.$citySelect.length && self.elems.$citySelect.parent().find('.item[data-value="' + realCityID + '"] button').length && self.elems.$citySelect.val() != realCityID) {
                                    self.elems.$citySelect.val(realCityID)
                                    // помечаем что не надо менять глобальный город
                                    .data('changeGlobalCity', 0).change();
                                }
                            }
                        });
                    });
                }
            }, {
                key: "onCityChange",
                value: function onCityChange(value, changeGlobalCity) {
                    var self = this;
                    $(this.swiper.$wrapperEl).animate({ opacity: 0 }, 500);
                    if (changeGlobalCity) {
                        window.setCity(window.cities[value].name, false, true, function () {
                            self.onSetCity(value);
                        });
                    } else {
                        this.onSetCity(value);
                    }
                }
            }, {
                key: "onSetCity",
                value: function onSetCity(value) {
                    var $mobileMainCitySelect = $('#s_mainCitySelect');
                    $mobileMainCitySelect.trigger('contactDrawn');

                    if (value in this.cache) {
                        this.changeOffers(this.cache[value]);
                    } else {
                        this.elems.$spinner.removeClass('hide');
                        var self = this;
                        $.ajax({
                            url: '/widget/getHotOffers',
                            type: 'GET',
                            dataType: 'json',
                            data: { city: value, type: 'only', mobile: 1 }
                        }).done(function (data) {
                            self.cache[value] = data;
                            self.changeOffers(data);
                            self.elems.$spinner.addClass('hide');
                        });
                    }
                }
            }, {
                key: "changeOffers",
                value: function changeOffers(data) {
                    if (data.length) {
                        this.swiper.detachEvents();

                        //this.swiper.$wrapperEl.css('margin-left', 0);
                        //this.$arrows.removeClass('w-of-control__disabled');
                        //$('.w-of-control__left').addClass('w-of-control__disabled');

                        var html = '';
                        var days_class;
                        var params = ['link', 'title', 'file', 'info'];
                        var t;
                        var value;
                        var index = 0;
                        for (var k in data) {
                            var offer = data[k];

                            var tpl = this.template.main;
                            tpl = tpl.split('{{lazyImgParams}}').join(index > 0 ? 'class="swiper-lazy" data-' : '');
                            tpl = tpl.split('{{lazyPreloader}}').join(index > 0 ? this.template.lazyPreloader : '');

                            var daysTemplate = data[k].hasOwnProperty('hideDaysToEnd') && parseInt(data[k].hideDaysToEnd) ? '' : this.template.days;
                            tpl = tpl.split('{{days_template_place}}').join(daysTemplate);

                            if ('' !== offer['price'] && '0' != offer['price']) {
                                t = window.utils.i18nTemplate(this.translate.priceFromText, {
                                    price: offer['price'] + offer['cur']
                                });
                            } else {
                                t = '&nbsp;';
                            }
                            tpl = tpl.split('{{price_place}}').join(t);
                            tpl = tpl.split('{{leftText}}').join(this.translate.leftText);
                            tpl = tpl.split('{{days_place}}').join(offer['daysToEnd'] + ' ' + getnoun(offer['daysToEnd'], this.translate.pluralDays[0], this.translate.pluralDays[1], this.translate.pluralDays[2]));
                            tpl = tpl.split('{{view_tour}}').join(this.translate.viewLabel);
                            t = "";
                            if (0 < offer['discount']) {
                                t += this.template.discount.split('{{discount_value}}').join(offer['discount'] + '%');
                            }
                            tpl = tpl.split('{{discount_template_place}}').join(t);
                            t = '';
                            tpl = tpl.split('{{depart_place}}').join(t);
                            t += this.template.country.split('{{country_name}}').join(offer['country']['name']).split('{{country_code}}').join(offer['country']['code']);
                            tpl = tpl.split('{{country_template_place}}').join(t);

                            for (var j in params) {
                                value = offer[params[j]];
                                if (params[j] === 'file') {
                                    var isFromGalery = value.indexOf('gallery/') + 1; // parseInt(offer['autoUpdate'], 10);
                                    if (!isFromGalery) {
                                        value = 'big16x9/' + value;
                                    }
                                }
                                tpl = tpl.split('{{' + params[j] + '}}').join(value);
                            }

                            html += tpl;
                            index++;
                        }

                        html += this.template.all;

                        this.swiper.removeAllSlides();
                        this.swiper.prependSlide(html);
                        $(this.swiper.$wrapperEl).stop(true, true).animate({ opacity: 1 }, 200);

                        this.swiper.attachEvents();
                    }
                }
            }]);

            return HotelViewNew;
        }();

        window.HotOfferSlider = HotelViewNew;
    }, { "../../../../mobile-lite/include/modal/_js/modal": 6 }] }, {}, [7]);